<wbo-search-page >
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="myReportName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="contact">
                <wbo-employee-single-select-search-control></wbo-employee-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'report'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'lastUpdated'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="myReportName"></wbo-main-search-column>
        <wbo-column field="publicReport"></wbo-column>
        <wbo-open-link-column [linkPathResolver]="getLinkPath" [parameterResolver]="getParameter" field="report"></wbo-open-link-column>
        <wbo-date-time-column field="lastPublishTime"></wbo-date-time-column>
        <wbo-date-time-column field="nextPublishTime"></wbo-date-time-column>
        <wbo-column field="createdBy"></wbo-column>
        <wbo-checkbox-column field="myDefault" [editable]="false"></wbo-checkbox-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
            <wbo-myreport-unschedule-search-action></wbo-myreport-unschedule-search-action>
            <wbo-myreport-run-now-search-action></wbo-myreport-run-now-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
